import React from 'react'
import { Button, Checkbox, Divider, Dropdown, Menu, type MenuProps, Space, Switch } from 'antd'
import { BarChartOutlined, CaretDownFilled, SettingFilled } from '@ant-design/icons'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Popover } from 'antd'

const items: MenuProps['items'] = []

export const markerOptions = ['Tank Size', 'Max Physical Volume', 'Target Max', 'Target Min', 'Min Physical Volume']

export const getInitialMarkerState = () =>
  markerOptions.reduce((acc, m) => ({ ...acc, [m]: ['Target Min', 'Target Max'].includes(m) ? true : false }), {})

const GraphLineToggle = ({ toggled, marker, onToggle }) => {
  return (
    <Horizontal
      onClick={(e) => {
        e.stopPropagation()
      }}
      style={{ width: '100%', gap: '0.25rem' }}
      alignItems='center'
    >
      <Checkbox checked={toggled} onChange={onToggle} className='mr-2' />
      <Texto category='label'>{marker}</Texto>
      <div style={{ flexGrow: 1 }} />
    </Horizontal>
  )
}

export const TankGraphWidget = ({ graphMarkers, onMarkerChange }) => {
  const handleMenuClick: MenuProps['onClick'] = (e) => {}

  const menuProps = {
    items,
    onClick: handleMenuClick,
  }

  const menu = (
    <Space direction='vertical' style={{ minWidth: 175 }}>
      <Texto category='heading-small' appearance='medium'>
        <BarChartOutlined className='mr-3 mb-1' />
        Graph Lines
      </Texto>
      <hr />

      {markerOptions.map((m) => (
        <GraphLineToggle key={m} toggled={graphMarkers[m]} marker={m} onToggle={() => onMarkerChange(m)} />
      ))}
    </Space>
  )

  return (
    <Popover content={menu} trigger='hover' placement='bottomRight'>
      <a>
        <Texto className='text-ellipsis' appearance='medium' weight='bold'>
          Configure Graph <CaretDownFilled />
        </Texto>
      </a>
    </Popover>
  )
}
